import React from 'react'
import "./SiteFooter.css"
import { FaInstagram, FaYoutube } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { NavLink } from 'react-router-dom';
import AT from '../../Images/Mandli/at_logo.svg';
import footerMountain from '../../Images/Mandli/FooterMountain.svg'
import FooterMountainMobile from '../../Images/Mandli/FooterMountainMobile.svg'
import { AiOutlineYoutube } from "react-icons/ai";
import leftImage from '../../Images/Mandli/tree-left.svg'
import rightImage from '../../Images/Mandli/tree-right.svg'
import footerTreesMobile from '../../Images/Mandli/footer_tress_mobile.svg'
import mailsvg from '../../Images/Mandli/mailsvg.svg'

function SiteFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className='Footer'>

        <img className="footer-mountain hideinmobile" src={footerMountain} alt="" />
        <img className="footer-mountain hideInDesktop" src={FooterMountainMobile} alt="" />


        <div className="get-in-touch footer-get-in-touch">
          <img className='left-tree hideinmobile' src={leftImage} alt="tree image" />

          <div className='footer-content-wrapper'>
            <h2>get <span>in touch</span></h2>
            <div className="contact-info">
              <a href='tel:+918780755209' className='contact-details'><IoCallOutline /> +91-87807 55209</a>
              <div className="social-links">
                <p className='contact-details'>Connect with us:</p>
                <a href="https://www.instagram.com/mandli_garba" target="_blank"><FaInstagram /></a>
                <a href="https://www.youtube.com/@Mandli_Garba" target="_blank"><AiOutlineYoutube /></a>
              </div>
              <a href='mailto:commoneventsplanningteam@gmailcom' className='contact-details'><img src={mailsvg} alt="mail" /> commoneventsplanningteam@gmail.com</a>
            </div>
            {/* <div className='footer-divider'></div> */}
            {/* <div className='legal-links'>
              <a href="/support">Support</a>
              <div class='divider-vertical'></div>
              <a href="#">Privacy Policy</a>
            </div>
            <div className='legal-links'>
              <a href="#">Terms of Service</a>
              <div class='divider-vertical'></div>
              <a href="#">Refund & Cancellation</a>
            </div> */}
            <div className='footer-divider'></div>
            <div className='main-footer'>
              <p>© Mandli 2026</p>
              <a href="https://ahuratechnosoft.com/" target='_blank' className="designed-by">
                <p>Designed and Developed by </p>
                <img src={AT} alt='Designed and Developed by AT' />
              </a>
            </div>
          </div>
          <img src={rightImage} className='hideinmobile' alt="tree image" />

          <img src={footerTreesMobile} className='hideInDesktop' alt="" />
        </div>


        {/* Bottom copyright */}
        {/* <div className='Site_footer'>
					<div className='container'>
						<div className='coppy_rights'>
							<h1>&copy; {currentYear} Mandli</h1>
						</div>
						<div className="design_devlop_At">
							<NavLink to="https://ahuratechnosoft.com" >
								<h1>Designed and Developed by</h1>
								<img src={AT} alt='Designed and Developed by AT' />
							</NavLink>
						</div>
					</div>
				</div> */}
      </div>
    </>
  )
}

export default SiteFooter
